export const AuthEndpoints = {
  login: '/api-sis/Auth/login',
} as const;

export type AuthEndpointKey = keyof typeof AuthEndpoints;